import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { adminLogin, formatApiError } from "../../lib/api";
import { Input } from "../../components/ui/input";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await adminLogin(email.trim(), password);
      localStorage.setItem("rvi_admin_token", res.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[70vh] flex items-center justify-center px-4 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-gold/40 bg-ivory p-8 sm:p-10 shadow-sm">
        <div className="text-center">
          <span className="inline-flex w-12 h-12 items-center justify-center bg-maroon text-ivory rounded-full">
            <Lock className="w-5 h-5" strokeWidth={1.5} />
          </span>
          <h1 className="font-heading text-2xl sm:text-3xl text-charcoal mt-4">Owner Login</h1>
          <p className="text-sm text-charcoal/50 mt-2">Private panel for R V Ilkal Sarees</p>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-xs tracking-[0.12em] uppercase text-charcoal/50">Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              data-testid="admin-email-input"
              className="mt-2 bg-ivory border-gold/40 rounded-sm h-12 focus-visible:ring-gold"
              required
            />
          </div>
          <div>
            <label className="text-xs tracking-[0.12em] uppercase text-charcoal/50">Password</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your password"
              data-testid="admin-password-input"
              className="mt-2 bg-ivory border-gold/40 rounded-sm h-12 focus-visible:ring-gold"
              required
            />
          </div>
          {error && (
            <p className="text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-2.5" data-testid="admin-login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-maroon text-ivory text-xs tracking-[0.18em] uppercase py-4 hover:bg-maroon-dark transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <Link to="/" className="block text-center text-xs text-charcoal/50 hover:text-maroon mt-6 underline underline-offset-4" data-testid="admin-back-home">
          Back to store
        </Link>
      </div>
    </main>
  );
}
